var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIgnoreTerm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.008,
    height: 20.008,
    viewBox: "0 0 20.008 20.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-hide",
    transform: "translate(0.043 -0.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26719",
    "data-name": "Path 26719",
    d: "M19.258,14a.664.664,0,1,0,.664.664A.664.664,0,0,0,19.258,14ZM.664,14a.664.664,0,1,0,.664.664A.664.664,0,0,0,.664,14Z",
    transform: "translate(0 -4.367)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26720",
    "data-name": "Path 26720",
    d: "M6.33,8.816a4.645,4.645,0,1,1,6.511,6.511l1.814,1.814A13.327,13.327,0,0,0,19.869,12l-.023-.754S15.993,5,10.016,5A9.871,9.871,0,0,0,4.407,6.893ZM11.631,16a4.638,4.638,0,0,1-5.969-5.969L3.343,7.707a16.762,16.762,0,0,0-3.157,3.54L.163,12s3.212,6.28,9.853,6.28a9.981,9.981,0,0,0,3.334-.567Z",
    transform: "translate(-0.055 -1.344)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26721",
    "data-name": "Path 26721",
    d: "M18.887,20.3.293,1.707,1.707.293,20.3,18.887Z",
    transform: "translate(-0.336 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26722",
    "data-name": "Path 26722",
    d: "M15.063,15.9a2.651,2.651,0,1,0-3.65-3.65Zm-4.052-2.174A2.649,2.649,0,0,0,13.585,16.3Z",
    transform: "translate(-3.699 -3.359)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgnoreTerm);
export default __webpack_public_path__ + "static/media/IgnoreTerm.40364123b92c60915af56da4241cda8e.svg";
export { ForwardRef as ReactComponent };